import { PropsWithChildren } from 'react'

const Menu = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex w-full flex-col bg-white">
      <div>{children}</div>
    </div>
  )
}
export default Menu
